module.exports = __webpack_public_path__ + "static/img/nx_m.cee894ba.png";